import { hasCapability, type User } from "../base";

export const recruitingTriage = {
  read: (user: User) => hasCapability(user, "recruitingTriage.read"),
  resolve: (user: User) => hasCapability(user, "recruitingTriage.resolve"),
};
